// extracted by mini-css-extract-plugin
module.exports = {"container":"mygHAfc7KuQVw47b7rWvS","spinner":"u8A2JJE1JybQ3JwP8dj0C"};